<template>
  <div class="card p-3 lista around border-0">
    <ul class="nav nav-tabs" id="dados-tab" role="tablist">
      <li
        class="nav-item col px-0"
        role="presentation"
        v-if="formasPagamento.cartaocredito"
      >
        <a
          class="nav-link active"
          data-toggle="tab"
          href
          role="tab"
          aria-controls="home"
          aria-selected="true"
          @click="payment = 1"
          ><i class="material-icons pr-2">credit_card</i>Cartão de Crédito</a
        >
      </li>
      <li
        class="nav-item col px-0"
        role="presentation"
        v-if="formasPagamento.cartaodebito"
      >
        <a
          class="nav-link"
          data-toggle="tab"
          href
          role="tab"
          aria-controls="home"
          aria-selected="false"
          @click="payment = 4"
          ><i class="material-icons pr-2">credit_card</i>Cartão de Débito</a
        >
      </li>
      <li
        class="nav-item col px-0"
        role="presentation"
        v-if="formasPagamento.boleto.status"
      >
        <a
          class="nav-link"
          data-toggle="tab"
          href
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          @click="payment = 2"
          ><i class="material-icons pr-2">receipt</i>Boleto</a
        >
      </li>
      <li
        class="nav-item col px-0"
        role="presentation"
        v-if="formasPagamento.mensalidade"
      >
        <a
          class="nav-link"
          data-toggle="tab"
          href
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          @click="payment = 3"
          ><i class="material-icons pr-2">receipt</i>Incluir na Mensalidade</a
        >
      </li>
    </ul>
    <CartaoCredito
      v-if="payment == 1"
      @click="pagamentoCartao"
      :loading="loading"
    />
    <CartaoDebito
      v-if="payment == 4"
      @click="pagamentoCartaoDebito"
      :loading="loading"
    />
    <Boleto
      v-if="payment == 2"
      :msg="formasPagamento.boleto.msg"
      @click="pagamentoBoleto"
      class="mt-2"
      :loading="loading"
    />
    <Mensalidade
      v-if="payment == 3"
      @click="pagamentoMensalidade"
      class="mt-2"
      :loading="loading"
    />
  </div>
</template>
<script>
import CartaoCredito from "@/components/pagamento/CartaoCredito";
import CartaoDebito from "@/components/pagamento/CartaoDebito";
import Boleto from "@/components/pagamento/Boleto";
import Mensalidade from "@/components/pagamento/Mensalidade";
export default {
  name: "ListPlanos",
  components: { CartaoCredito, Boleto, Mensalidade, CartaoDebito },
  props: {
    formasPagamento: {
      type: Object,
      default: () => {},
    },
    totalDependentes: {
      type: Number,
      default: 0,
    },
    precoPlanoAtual: {
      type: Number,
      default: 0,
    },
    planos: {
      type: Array,
      default: () => [],
    },
    validarAceite: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planoAtivo: 0,
      planoAtivoOpcao: 0,
      payment: 1,
    };
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  methods: {
    pagamentoBoleto(payload) {
      this.$emit("method", {
        payload: payload.props,
        type: "Boleto",
      });
    },
    pagamentoCartao(payload) {
      this.$emit("method", {
        payload: payload.props,
        type: "Cartao",
      });
    },
    pagamentoCartaoDebito(payload) {
      this.$emit("method", {
        payload: payload.props,
        type: "Debito",
      });
    },
    pagamentoMensalidade(payload) {
      this.$emit("method", {
        payload: payload.props,
        type: "Mensalidade",
      });
    },
  },
  computed: {
    planoAtivoInfo() {
      return this.planos[this.planoAtivo];
    },
    planoAtivoInfoOpcao() {
      return this.planos[this.planoAtivo].opcoes[this.planoAtivoOpcao];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.btn {
  outline: none;
  box-shadow: none;
}
.plan-tab-button {
  background: $dark-100;
  line-height: 1.4;
  .plan-active {
    font-size: 0.8rem;
    color: $medium-shade;
  }
  outline: none;
  &.active {
    background: white;
  }
}
.plan-tab-button-dropdown {
  background: white;
  &:hover {
    background: $dark-100;
  }
}
.option-tab-button {
  background: $dark-100;
  &.active {
    background: $primary;
    color: white;
  }
}
.nav-tabs {
  display: flex;
  justify-content: space-between;
  border: 0;
  margin-bottom: 10px;
  li {
    //width: 50%;
    a {
      color: #05428e !important;
      background: transparent;
      text-align: center;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    a.active {
      border: 2px solid #05428e;
      color: white !important;
      background: #05428e;
      border-radius: 5px;
      color: white;
      font-weight: 600;
    }
  }
}
.panel {
  background: white;
  padding: 2rem;
}
</style>
